import { render, staticRenderFns } from "./VendonTopUp.vue?vue&type=template&id=05664a66&scoped=true"
import script from "./VendonTopUp.vue?vue&type=script&lang=ts"
export * from "./VendonTopUp.vue?vue&type=script&lang=ts"
import style0 from "./VendonTopUp.vue?vue&type=style&index=0&id=05664a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05664a66",
  null
  
)

export default component.exports